<template>
    <section id="product__scene__sticky" class="product__scene__sticky" ref="productSceneSticky">
        <section ref="productIntro" class="product_intro pst-100" data-scene-point>
            <div class="container">
                <div ref="productIntroWrapper" class="product_intro-wrapper">
                    <div ref="productIntroText" class="product_intro-headline" v-html="data.scrolledHeadline" />
                </div>
            </div>
        </section>
        <ProductExtended v-if="!!scrolledContent.length" :data="data" />
        <LazyProductScene
            v-if="!!scrolledContent.length && data.scrolledModelUrl"
            :url="data.scrolledModelUrl"
            :animation-steps="animationSteps"
            :start-model-position-desktop="data.startPositionDesktop"
            :start-model-position-mobile="data.startPositionMobile"
        />
    </section>
</template>

<script setup>
    const props = defineProps({
        data: {
            type: Object,
            default: () => ({})
        }
    });

    const { $gsap: gsap, $SplitText: SplitText } = useNuxtApp();

    const productSceneSticky = ref(null);
    const productIntro = ref(null);
    const productIntroText = ref(null);
    const productIntroWrapper = ref(null);

    const scrolledContent = computed(() => useCmsArray(props.data.scrolledContent));

    const animationSteps = computed(() =>
        !!scrolledContent.value.length
            ? scrolledContent.value.map((item) => ({
                  position: useCmsFirst(item.modelPosition) || { x: 0, y: 0, z: 0 },
                  rotation: useCmsFirst(item.modelRotation) || { x: 0, y: 0, z: 0 },
                  animation: item.animation,
                  animationName: item.animationName
              }))
            : [{}]
    );

    useStartAnimations(() => {
        if (productIntroText.value) {
            const splitted = new SplitText(productIntroText.value, { type: "chars, words" });

            gsap.set(splitted.chars, {
                filter: "grayscale(100%)",
                opacity: 0.25
            });

            gsap.timeline({
                scrollTrigger: {
                    trigger: productIntroWrapper.value,
                    start: "-10% top",
                    pin: true,
                    pinSpacer: true,
                    scrub: 1,
                    invalidateOnRefresh: true
                }
            }).to(splitted.chars, {
                filter: "grayscale(0%)",
                opacity: 1,
                stagger: 0.05,
                ease: "none"
            });
        }
    });
</script>
